export const appcat = 'delivery';